import { render, staticRenderFns } from "./CollapsableSelectionList.vue?vue&type=template&id=8c1f7208"
import script from "./CollapsableSelectionList.vue?vue&type=script&lang=js"
export * from "./CollapsableSelectionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports